import Module, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import FirstChargeView from "./firstcharge_view";
import ActivityUtil from "../activity/activity_util";
import ModuleManager from "../../../../framework/core/module_manager";
import GoogleBillingController from "../../../../sdk/googlebilling_controller";
import { AutoDialogManager } from "../../../../manager/auto_dialog_manager";
import NetPrompt from "../../../public/module/netprompt/netprompt";
import { TaskHelp, TaskCode } from "../gametask/task_help";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit("FirstCharge")
export default class FirstCharge extends Module<FirstChargeView,null> {
    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/hall/module/firstcharge/firstcharge";
        this.viewType = FirstChargeView
        this.modelType = null
        this.autoShowAnim = true
        this.needAnim = true
        this.needViewMask = true
        this.needViewBaseCloseBtn = true;
        this.needViewBaseTitleBg = false
        this.needViewBaseBg = false
        this.needDeferShow = true
        this.clickAnywhereClose = false;
    }

    activityData:any = {}
    onInit(intenData){
        this.eventBind('googleBillingPurchaseSuccess',this.googleBillingPurchaseSuccess);
    }

    onDeferShow(intenData) {
        let self = this
        this.getData(function(data){
            self.view.updatePanel(data);
            if(!self.isFinishActivity()){
                self.show();
            }
            ActivityUtil.refreshModuleOpenTime('FirstCharge')
        })
    }

    private getData(finish:Function){
        let self = this;
        TaskHelp.getTask(TaskCode.first_goods,(detail,progress)=>{
            if (detail == null) {
                self.hide();
                AutoDialogManager.openPriorityUI();
                self.eventDispatch('refresh_firstCharge',false);
                ActivityUtil.setFisrtCharege(1)
            }else{
                let curGroup = progress.currentConditionGroup;
                self.activityData.progress = curGroup;
                self.activityData.awards = detail.awards;
                self.activityData.awards.sort((a:any,b:any)=>{
                    return a.activityConditionGroup-b.activityConditionGroup;
                })
                self.activityData.isReceive = progress.isReceive;
                self.activityData.isFinish = progress.isFinish;
                let endGroup = detail.awards[detail.awards.length-1];
                if (endGroup) {
                    self.activityData.endGroup = endGroup.activityConditionGroup
                }else{
                    self.activityData.endGroup = 0;
                }
                if (self.isFinishActivity()) {
                    self.hide();
                    AutoDialogManager.openPriorityUI();
                    self.eventDispatch('refresh_firstCharge',false);
                    ActivityUtil.setFisrtCharege(1)
                }
                finish && finish(self.activityData);
            }
        },()=>{},this);
    }

    isFinishActivity(){
        let awards = this.activityData.awards;
        if (awards.length == 0) {//没有
            return true
        }else{
            let endAward = awards[awards.length-1]
            if (endAward) {
                if (this.activityData.progress >= endAward.activityConditionGroup) {
                    if (this.activityData.isFinish) {//是否完成
                        return true;
                    }
                }
            }
            return false;
        }
    }

    getAwardData(progress:number){
        let awards = this.activityData.awards;
        for (let index = 0; index < awards.length; index++) {
            let award = awards[index];
            if (award && award.activityConditionGroup == progress) {
                return award;
            }       
        }
        return null;
    }

    @bindButtonClickEvent('close_btn')
    close_btn(){
        this.hide();
        AutoDialogManager.openPriorityUI();
    }

    @bindButtonClickEvent('discount_btn')
    buyGoods_btn(){
        this.buyGoods();
    }

    private buyGoods(){
        let data = this.getCurAward();
        if (data) {
            if (data.goodsVo != undefined) {
                ModuleManager.instance.showModuleName("NetPrompt", { showImmediately: true })
                GoogleBillingController.purchaseInApp(data.goodsVo.goodsCode);
            }
        }
    }

    private showByGoodsAnim(skuId:string){
        let awards = this.activityData.awards;
        let gold = 0;
        for (let i = 0; i < awards.length; i++) {
            let award = awards[i].goodsVo;
            if (award.goodsCode == skuId) {
                for (let j = 0; j < award.giftList.length; j++) {
                    let gift = award.giftList[j];
                    gold += gift.num;
                }
                gold += award.num
                break;
            }
        }
        ModuleManager.instance.showModuleName('DialogReceive', {chipNum: null, goldNum: gold})
        this.getSelfCurrencyData(null, true)
        this.eventDispatch('player_coinbalance_changed');
        this.activityData.progress += 1;//执行下个
        this.activityData.isFinish = this.activityData.progress > this.activityData.endGroup
        if (this.isFinishActivity()) {
            this.hide();
            AutoDialogManager.openPriorityUI();
            this.eventDispatch('refresh_firstCharge',false);
            ActivityUtil.setFisrtCharege(1)
        }else{
            this.view.updatePanel(this.activityData);
        }
    }

    getCurAward(){
        let progress = this.activityData.progress 
        let data = this.getAwardData(progress);
        return data;
    }

    googleBillingPurchaseSuccess(skuId:string){
        this.showByGoodsAnim(skuId);
    }
}
